import React from 'react';

import ColorsFilter from 'components/essentials/ColorsFilter';
import useAdvancedSearchContext from 'components/consumer/consumer-search/advanced-search-next/hooks/useAdvancedSearchContext';

const ProductListingColorFilter = ({ colors = [] }) => {
  const { selectedColors, selectColor } = useAdvancedSearchContext();

  if (!colors.length || !colors) {
    return null;
  }

  return (
    <ColorsFilter
      colors={colors}
      onSelectColor={selectColor}
      selectedColors={selectedColors}
    />
  );
};

export default ProductListingColorFilter;
